import React, { useState } from "react";
import {
  makeStyles,
  Grid,
  List,
  ListItem,
  Typography,
  Box,
  AppBar,
  Tabs,
  Tab,
  Paper,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";

import { useSpring, animated } from "react-spring";

import WebtoonSlider from "../../../../Sliders/WebtoonSlider";
import WebtoonSlickSlider from "../../../../Sliders/WebtoonSlickSlider";

const useStyles = makeStyles((theme) => ({
  bgStyle: {
    "&:hover": {
      // background: "rgba(0,0,0,.05)",
    },
  },
  imgBg: {
    backgroundImage:
      // "url(https://images.unsplash.com/photo-1524222717473-730000096953?ixlib=rb-0.3.5&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1080&fit=max&ixid=eyJhcHBfaWQiOjExNzczfQ&s=8b1938d0d4ef26e336db84568708980a)",
      // "url(images/main/airdryer/adsorption_air_dryer/heater_type.png)",
      "url(images/main/airdryer/refri.jpg)",

    position: "absolute",
    zIndex: -2,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    width: "100%",
    height: "100%",
    borderRadius: "var(--border-radius-primary)",
    // padding: "40px 38px 45px",
    background: "no-repeat center center",
    // backgroundSize: "50%",
    backgroundSize: "cover",
    "&::before": {
      display: "block",
      width: "100%",
      height: "100%",
      content: '" "',
      opacity: ".4",
      backgroundImage: " linear-gradient(234deg,#394245,#000)",
    },
    // border: "1px solid",
    willChange: "transform",
  },
  objBg: {
    // backgroundImage:
    //   "url(images/main/airdryer/adsorption_air_dryer/heater_type.png)",
    position: "absolute",
    zIndex: -1,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    width: "100%",
    height: "100%",
    borderRadius: "var(--border-radius-primary)",
    // padding: "40px 38px 45px",
    background: "no-repeat 93% 50%",
    backgroundSize: "60%",
    filter: "brightness(0.4)",
    // "&::before": {
    //   display: "block",
    //   width: "100%",
    //   height: "100%",
    //   content: '" "',
    //   opacity: ".4",
    //   backgroundImage: " linear-gradient(234deg,#394245,#000)",
    // },
    // border: "1px solid",
    willChange: "transform",
  },
  txtStyle: {
    // color: "black",
    color: "white",
    fontWeight: "bold",
    fontFamily: "Noto Sans KR",
  },
  subTitleStyle: {
    // color: "black",
    color: "#e77842",
    fontFamily: "Noto Sans KR",
    lineHeight: 1.6,
    fontSize: 19,
    fontWeight: 700,
    letterSpacing: "0.15px",
  },
  subtxtStyle: {
    // color: "black",
    color: "white",
    fontFamily: "Noto Sans KR",
    fontWeight: 500,
    fontSize: 16,
  },
  bigIndicator: { backgroundColor: "rgb(188, 36, 60)" },
  tabRoot: {
    minWidth: 88,
  },
}));

interface ThreeThirdVideoProps {
  children: React.ReactNode | null | string | undefined;
}

// interface AspectDivVidoProps {
//   children: React.ReactNode;
// }

// function AspectDivVideo(props: AspectDivVideoProps) {
//   const classes = useStyles();

//   return (
//     <div className={classes.aspectRatioBox}>
//       <div className={classes.aspectRatioBoxInside}>
//         <div className={classes.fireboxCentering}>
//           <div className={classes.viewPortSizing}>{props.children}</div>
//         </div>
//       </div>
//     </div>
//   );
// }

function TwoSecondWebtoon() {
  const classes = useStyles();

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("xs"));

  const [{ sValue, brightValue, opacityValue, colorValue }, set] = useSpring(
    () => ({
      sValue: 1,
      brightValue: 0.4,
      opacityValue: 1,
      colorValue: "#e77842",
    })
  );

  const [value, setValue] = useState(0);
  const [webToonTitle, setWebToonTitle] = useState<any>(null);
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Grid
      xs={!matches ? 6 : 12}
      lg={!matches ? 6 : 12}
      item
      container
      justify={"center"}
    >
      <Paper
        elevation={0}
        component={animated.article}
        style={{
          width: "100%",
          zIndex: 0,
          overflow: "hidden",
          position: "relative",

          willChange: "transform",
          minHeight: !matches ? 480 : 193,
          maxHeight: !matches ? 480 : 193,
          // padding: "1rem 2rem 2rem 2rem",
          // backgroundImage:
          //   "linear-gradient(45deg,var(--gradient-orange-start),var(--gradient-orange-end))",
          borderRadius: 40,
          border: "1px solid #dadce0",
          //   margin: "15px 15px 15px 15px",
          margin: 15,
          boxSizing: "border-box",
          // transform: sValue.interpolate((sValue) => `scale(${sValue}`),
        }}
        // onMouseEnter={() =>
        //   set({ sValue: 1.03, brightValue: 1, opacityValue: 0 })
        // }
        // onMouseLeave={() =>
        //   set({ sValue: 1, brightValue: 0.4, opacityValue: 1 })
        // }
      >
        {/* <VideoSlider /> */}
        <Grid
          xs={12}
          item
          container
          alignItems={"center"}
          style={{ height: "15%" }}
        >
          <Grid
            xs={!matches ? 3 : 3}
            item
            container
            style={{
              paddingLeft: !matches ? 48 : 24,
              fontFamily: "Noto Sans Kr",
              fontWeight: 700,
              fontSize: !matches ? 23 : 16,
              paddingTop: !matches ? 8 : 4,
              paddingBottom: !matches ? 8 : 4,
              letterSpacing: !matches ? 8 : 4,
            }}
          >
            웹툰
          </Grid>
          <Grid
            xs={!matches ? 9 : 9}
            item
            container
            style={{
              fontFamily: "Noto Sans Kr",
              fontSize: 16,
              lineHeight: 1.334,
              paddingTop: 2,
              fontWeight: 500,
              letterSpacing: 0,
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflowWrap: "normal",
              overflow: "hidden",
            }}
          >
            {webToonTitle}
          </Grid>
        </Grid>
        <WebtoonSlider setWebToonTitle={setWebToonTitle} />
        {/* <WebtoonSlickSlider setWebToonTitle={setWebToonTitle} /> */}
      </Paper>
    </Grid>
  );
}

// export default MainContainer;
export default TwoSecondWebtoon;

// export default MainContainer;
